<template>
  <div class="loading-spinner d-flex justify-content-center">
    <div class="loading-spinner-animation" data-cy="spinner-animation">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "Spinner",
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
@keyframes loading-spinner-animation {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.loading-spinner-animation {
  width: 100%;
  height: 100%;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -50px;
  left: -15px;

  & > span {
    display: block;
    left: 89px;
    top: 49px;
    position: absolute;
    animation: loading-spinner-animation linear 1s infinite;
    background: $pj-color-yellow-green;
    width: 22px;
    height: 22px;
    border-radius: 11px;
    transform-origin: 11px 51px;
    box-sizing: content-box;
    &:nth-child(1) {
      transform: rotate(0deg);
      animation-delay: -0.875s;
    }
    &:nth-child(2) {
      transform: rotate(45deg);
      animation-delay: -0.75s;
    }
    &:nth-child(3) {
      transform: rotate(90deg);
      animation-delay: -0.625s;
    }
    &:nth-child(4) {
      transform: rotate(135deg);
      animation-delay: -0.5s;
    }
    &:nth-child(5) {
      transform: rotate(180deg);
      animation-delay: -0.375s;
    }
    &:nth-child(6) {
      transform: rotate(225deg);
      animation-delay: -0.25s;
    }
    &:nth-child(7) {
      transform: rotate(270deg);
      animation-delay: -0.125s;
    }
    &:nth-child(8) {
      transform: rotate(315deg);
      animation-delay: 0s;
    }
  }
}
.loading-spinner {
  width: 200px;
  height: 200px;
  margin: 0 auto;
  display: inline-block;
  overflow: hidden;
}
</style>
